module.exports = __webpack_public_path__ + "static/media/Icon-dwelling.278f6d31.svg";